if (!window.__featuredItemsSizeOverlayInit) {
  window.__featuredItemsSizeOverlayInit = true;

  document.addEventListener('click', function (event) {
    const button = event.target.closest('.featured-items__size-btn');
    if (!button) return;

    const overlay = button.closest('.featured-items__size-overlay');
    if (!overlay) return;

    overlay.querySelectorAll('.featured-items__size-btn').forEach((btn) => {
      btn.classList.toggle('is-selected', btn === button);
    });

    const idInput = overlay.querySelector('input[name="id"]');
    const submitButton = overlay.querySelector('.featured-items__size-submit');
    const available = button.dataset.available === 'true';
    const variantId = button.dataset.variantId;

    if (idInput && variantId) {
      idInput.value = variantId;
      idInput.disabled = !available;
    }

    if (submitButton) {
      submitButton.disabled = !available || !variantId;
      submitButton.classList.toggle('is-disabled', !available || !variantId);

      const label = submitButton.querySelector('span');
      if (label) {
        label.textContent = available
          ? submitButton.dataset.addToCartText
          : submitButton.dataset.soldOutText;
      }
    }
  });
}
